module.exports = __webpack_public_path__ + "static/media/sbs-logo.315f8ce8.png";